import React, { Component } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Dropdown } from "semantic-ui-react";
import Action from "../../common/Action";
import { Country, UserDetail, CompanyDetail, VatType } from "../Types";
import {
  getVatTypes,
  complexCountries,
  cutTextWithEllipsis,
  companyValidationSchema,
} from "../helpers";
import EmailSuggestions from "./EmailSuggestions";

interface Props {
  countries: Country[];
  vatTypes: VatType[];
  userDetails: UserDetail;
  companyDetails: CompanyDetail;
  isCurrentUserPresent: boolean;
  updateUserDetails: (key: string, value: string) => void;
  updateCompanyDetails: (key: string, value: string) => void;
  updateCompanyCountryDetails: (key: string, value: string) => void;
}

interface State {
  isDropdownVisible: boolean;
}

class CompanyForm extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isDropdownVisible: false,
    };
  }

  handleEmailSelection = (selectedEmail: string, setFieldValue) => {
    setFieldValue("email", selectedEmail);
    this.toggleDropdownVisibility(false);
  };

  toggleDropdownVisibility = (isVisible: boolean) => {
    this.setState({ isDropdownVisible: isVisible });
  };

  toggleDropdown = () => {
    this.state.isDropdownVisible
      ? this.toggleDropdownVisibility(false)
      : this.toggleDropdownVisibility(true);
  };

  handleChange = (e, key, setFieldValue) => {
    e.persist();

    const value = e.target.value;

    setFieldValue(key, value);

    this.props.updateCompanyDetails(key, value);

    if (key === "name") {
      this.props.updateUserDetails("name", value);
    }

    if (key === "email") {
      this.props.updateUserDetails("email", value);
      this.toggleDropdownVisibility(value.includes("@"));
    }
  };

  handleCountryChange = (e, data, setFieldValue) => {
    const { value } = data;

    setFieldValue("country", value);

    this.props.updateCompanyCountryDetails("country", value);
    this.props.updateUserDetails("country", value);
  };

  handleVatTypeChange = (e, data, setFieldValue) => {
    setFieldValue("vatType", data.value);

    this.props.updateCompanyDetails("vatType", data.value);
  };

  renderVatText = () => {
    switch (this.props.companyDetails.country) {
      case "AU":
        return "ABN";
      case "NZ":
      case "IN":
        return "GST";
      default:
        return "VAT";
    }
  };

  vatLabel = () => {
    const selected = this.props.vatTypes.find(
      (type) => type.value === this.props.companyDetails.vatType,
    );
    const text = selected ? selected.text : "";

    return cutTextWithEllipsis(text, 25);
  };

  render() {
    const {
      countries,
      userDetails,
      companyDetails,
      vatTypes,
      isCurrentUserPresent,
    } = this.props;

    return (
      <div className="special-fields" id="invoiceFields">
        <Formik
          initialValues={companyDetails}
          validationSchema={companyValidationSchema(isCurrentUserPresent)}
          onSubmit={() => {}}
        >
          {({ values, setFieldValue }) => (
            <Form className="ui form">
              <div className="input-row full">
                <div className="form-input">
                  <label>Company name</label>
                  <Field
                    id="billingName"
                    name="billingName"
                    validate={true}
                    className="required"
                    placeholder="Company Ltd"
                    onChange={(e) =>
                      this.handleChange(e, "billingName", setFieldValue)
                    }
                  />

                  <ErrorMessage name="billingName">
                    {(msg) => <div className="error">{msg}</div>}
                  </ErrorMessage>
                </div>
              </div>
              <div className="input-row full">
                <div className="form-input">
                  <label>Street address</label>
                  <Field
                    id="address"
                    name="address"
                    validate={true}
                    className=""
                    placeholder="123 High Street"
                    onChange={(e) =>
                      this.handleChange(e, "address", setFieldValue)
                    }
                  />

                  <ErrorMessage name="address">
                    {(msg) => <div className="error">{msg}</div>}
                  </ErrorMessage>
                </div>
              </div>
              <div className="input-row">
                <div className="form-input">
                  <label>City</label>
                  <Field
                    id="city"
                    name="city"
                    validate={true}
                    className=""
                    placeholder="London"
                    onChange={(e) =>
                      this.handleChange(e, "city", setFieldValue)
                    }
                  />
                  <ErrorMessage name="city">
                    {(msg) => <div className="error">{msg}</div>}
                  </ErrorMessage>
                </div>
                <div className="form-input">
                  <label>State / Region (optional)</label>
                  <Field
                    id="state"
                    name="state"
                    validate={true}
                    className=""
                    placeholder=""
                    onChange={(e) =>
                      this.handleChange(e, "state", setFieldValue)
                    }
                  />
                  <ErrorMessage name="state">
                    {(msg) => <div className="error">{msg}</div>}
                  </ErrorMessage>
                </div>
                <div className="field"></div>
              </div>
              <div className="input-row full">
                <div className="form-input">
                  <label>{this.renderVatText()} number (optional)</label>
                  <Field
                    id="vatNumber"
                    name="vatNumber"
                    validate={true}
                    placeholder="e.g. GB227725792"
                    onChange={(e) =>
                      this.handleChange(e, "vatNumber", setFieldValue)
                    }
                  />

                  <ErrorMessage name="vatNumber">
                    {(msg) => <div className="error">{msg}</div>}
                  </ErrorMessage>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

export default CompanyForm;
